exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bloqueo{\r\n    display: block !important;\n}\r\n", ""]);

// exports
